import { ApiUserAuth, endpoints_userAuthApi } from "./userAuthApi";
import { ApiEmpAdmin, endpoints_empAdmin } from "./EmpAdminApi";
import { ApiClasification, endpoints_clasification } from "./clasificationApi";
import { ApiQuestion, endpoints_question } from "./questionApi";
import {
  ApiUserAdmin,
  endpoints_userAdmin,
  endpoints_auditAdmin,
  endpoints_answerAdmin,
  endpoints_clientResponse,
} from "./userAdminApi";
import { ApiService, endpoints_service } from "./serviceApi";
import { ApiReport, endpoints_report } from "./reportApi";
import { ApiInputValue, endpoints_inputValue } from "./inputValueApi";
import { ApiLocalAdmin, endpoints_localAdmin } from "./localAdminApi";
import { ApiUserLocal, endpoints_userLocal } from "./userLocalApi";
import {
  ApiPredictiveModel,
  endpoints_predictive_model,
} from "./predictiveModelApi";

export {
  ApiUserAuth,
  ApiUserAdmin,
  endpoints_userAdmin,
  ApiService,
  endpoints_userAuthApi,
  endpoints_service,
  ApiEmpAdmin,
  endpoints_empAdmin,
  ApiClasification,
  endpoints_clasification,
  ApiQuestion,
  endpoints_question,
  ApiReport,
  endpoints_report,
  ApiInputValue,
  endpoints_inputValue,
  ApiLocalAdmin,
  endpoints_localAdmin,
  ApiUserLocal,
  endpoints_userLocal,
  ApiPredictiveModel,
  endpoints_predictive_model,
  endpoints_auditAdmin,
  endpoints_answerAdmin,
  endpoints_clientResponse,
};
